const countriesWithoutForbidden = ['AW', 'AF', 'AO', 'AI', 'AX', 'AL', 'AD', 'AN', 'AE', 'AR', 'AM', 'AS', 'AQ', 'TF', 'AG', 'AU', 'AT', 'AZ', 'BI', 'BE', 'BJ', 'BQ', 'BF', 'BD', 'BG', 'BH', 'BS', 'BA', 'BL', 'BY', 'BZ', 'BM', 'BO', 'BR', 'BB', 'BN', 'BT', 'BV', 'BW', 'CF', 'CA', 'CC', 'CH', 'CL', 'CN', 'CI', 'CM', 'CD', 'CG', 'CK', 'CO', 'KM', 'CV', 'CR', 'CW', 'CX', 'KY', 'CY', 'CZ', 'DE', 'DJ', 'DM', 'DK', 'DO', 'DZ', 'EC', 'EG', 'ER', 'EH', 'ES', 'EE', 'ET', 'FI', 'FJ', 'FK', 'FR', 'FO', 'FM', 'GA', 'GB', 'GE', 'GG', 'GH', 'GI', 'GN', 'GP', 'GM', 'GW', 'GQ', 'GR', 'GD', 'GL', 'GT', 'GF', 'GU', 'GY', 'HK', 'HM', 'HN', 'HR', 'HT', 'HU', 'ID', 'IM', 'IN', 'IO', 'IE', 'IQ', 'IS', 'IL', 'IT', 'JM', 'JE', 'JO', 'JP', 'KZ', 'KE', 'KG', 'KH', 'KI', 'KN', 'KR', 'KW', 'LA', 'LB', 'LR', 'LY', 'LC', 'LI', 'LK', 'LS', 'LT', 'LU', 'LV', 'MO', 'MF', 'MA', 'MC', 'MD', 'MG', 'MV', 'MX', 'MH', 'MK', 'ML', 'MT', 'MM', 'ME', 'MN', 'MP', 'MZ', 'MR', 'MS', 'MQ', 'MU', 'MW', 'MY', 'YT', 'NA', 'NC', 'NE', 'NF', 'NG', 'NI', 'NU', 'NL', 'NO', 'NP', 'NR', 'NZ', 'OM', 'PK', 'PA', 'PN', 'PE', 'PH', 'PW', 'PG', 'PL', 'PR', 'PT', 'PY', 'PS', 'PF', 'QA', 'RE', 'RO', 'RU', 'RW', 'SA', 'SD', 'SN', 'SG', 'GS', 'SH', 'SJ', 'SB', 'SL', 'SV', 'SM', 'SO', 'PM', 'RS', 'SS', 'ST', 'SR', 'SK', 'SI', 'SE', 'SZ', 'SX', 'SC', 'TC', 'TD', 'TG', 'TH', 'TJ', 'TK', 'TM', 'TL', 'TO', 'TT', 'TN', 'TR', 'TV', 'TW', 'TZ', 'UG', 'UA', 'UM', 'UY', 'US', 'UZ', 'VA', 'VC', 'VE', 'VG', 'VI', 'VN', 'VU', 'WF', 'WS', 'YE', 'ZA', 'ZM', 'ZW'];
export function getCountryField(
// required will be replaced with FieldSettings country once we have it in the proto
required, multilineAddressOptions) {
  var _multilineAddressOpti, _multilineAddressOpti2;
  return {
    id: '1e445376-d280-4cda-9ffa-18b61c2881c7',
    target: 'country',
    pii: true,
    hidden: false,
    view: {
      fieldType: 'MLA_COUNTRY',
      options: multilineAddressOptions != null && (_multilineAddressOpti = multilineAddressOptions.allowedCountries) != null && _multilineAddressOpti.length ? multilineAddressOptions == null ? void 0 : multilineAddressOptions.allowedCountries : countriesWithoutForbidden.map(country => ({
        value: country
      }))
    },
    validation: {
      required: Boolean(required),
      string: {
        enum: multilineAddressOptions != null && (_multilineAddressOpti2 = multilineAddressOptions.allowedCountries) != null && _multilineAddressOpti2.length ? multilineAddressOptions == null ? void 0 : multilineAddressOptions.allowedCountries : countriesWithoutForbidden
      }
    }
  };
}
export function getCountryFieldLayout() {
  return {
    fieldId: '1e445376-d280-4cda-9ffa-18b61c2881c7',
    row: 0,
    column: 0,
    width: 12,
    height: 1
  };
}
//# sourceMappingURL=get-country-field.js.map